import React, { useLayoutEffect } from 'react'

/**
 * 在 React SPA 内通过客户端路由进入 /admin/* 时，整页重载以让 Vite 代理到若依子应用。
 * 直接访问 http://localhost:8088/admin/ 时由代理返回若依 HTML，不经过本组件。
 */
const RuoyiAdminRedirect: React.FC = () => {
  useLayoutEffect(() => {
    const path = window.location.pathname + window.location.search + window.location.hash
    window.location.replace(path)
  }, [])
  return (
    <div style={{ padding: 24, textAlign: 'center' }}>
      正在进入若依管理端…
    </div>
  )
}

export default RuoyiAdminRedirect
